// import React from 'react'
// import title from "../images/titile.png"
// import BannerText1 from './BannerText1'

// function BannerTitle1() {
//   return (
//     <div className="card-img-overlay text-center" id="heading">
//           <img src={title} alt="" width="500px" />
//         <BannerText1/>
//         </div>
//   )
// }

// export default BannerTitle1

import React from 'react'
import BannerText1 from './BannerText1'


const BannerTitle1 = ({ bTitle, bText }) => {
  return (
    <>
       <div className=" banner-title-overlay text-center" id="heading">
          <img src={bTitle} alt="" className='banner-title-image'/>
          <BannerText1 bText={bText} className="banner-title-text"/>
      </div>
    </>
 
  )
}

export default BannerTitle1